import { useState, useEffect } from 'react';

export const useMouseDepthEffect = (options = {}) => {
  const {
    friction = 1 / 60,
    perspective = 600,
    maxRotate = 2, // Max rotation in degrees
  } = options;

  const [transform, setTransform] = useState({
    offsetX: 0,
    offsetY: 0,
  });

  useEffect(() => {
    const handleMouseMove = (e) => {
      // Calculate how far the mouse is from the center of the window
      const followX = (window.innerWidth / 2 - e.clientX);
      const followY = (window.innerHeight / 2 - e.clientY);
      
      // Calculate rotation based on mouse position, with maxRotate as a limit
      let rotateY = -followX * friction;
      let rotateX = followY * friction;
      
      // Limit rotation to maxRotate degrees
      rotateY = Math.max(Math.min(rotateY, maxRotate), -maxRotate);
      rotateX = Math.max(Math.min(rotateX, maxRotate), -maxRotate);

      setTransform({
        offsetX: rotateX,
        offsetY: rotateY,
      });
    };

    // Add event listener
    document.addEventListener('mousemove', handleMouseMove);

    // Clean up
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [friction, maxRotate]);

  // Return style object to be applied to the element
  const style = {
    transform: `perspective(${perspective}px) rotateX(${transform.offsetX}deg) rotateY(${transform.offsetY}deg)`,
    transition: 'transform 0.1s ease-out',
  };

  return { style };
}; 